import React, { memo, useCallback } from 'react';
import { useInlineEdit } from '../../hooks';
import {
  Container,
  DisplayButton,
  DisplayText,
  Input,
} from './InlineEditableText.styled';

const InlineEditableText = ({
  value,
  placeholder = '',
  variant = 'description',
  onChange,
}) => {
  const {
    isEditing,
    draftValue,
    setDraftValue,
    startEdit,
    cancelEdit,
    commitEdit,
  } = useInlineEdit({
    initialValue: value || '',
    onCommit: onChange,
  });

  const focusRef = useCallback((node) => {
    if (!node) return;
    node.focus();
    node.select();
  }, []);

  const handleInputChange = useCallback((event) => {
    setDraftValue(event.target.value);
  }, [setDraftValue]);

  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      commitEdit();
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      cancelEdit();
    }
  }, [cancelEdit, commitEdit]);

  const handleStartEdit = useCallback(() => {
    startEdit(value || '');
  }, [startEdit, value]);

  const displayValue = value || placeholder;
  const isPlaceholder = !value;

  if (isEditing) {
    return (
      <Container>
        <Input
          ref={focusRef}
          $variant={variant}
          value={draftValue}
          onChange={handleInputChange}
          onBlur={commitEdit}
          onKeyDown={handleKeyDown}
        />
      </Container>
    );
  }

  return (
    <Container>
      <DisplayButton
        type="button"
        onClick={handleStartEdit}
        aria-label={`Edit ${variant}`}
      >
        <DisplayText $variant={variant} $isPlaceholder={isPlaceholder}>
          {displayValue}
        </DisplayText>
      </DisplayButton>
    </Container>
  );
};

export default memo(InlineEditableText);
